import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import alertStore from './modules/alert'
import authStore from './modules/auth'
import lenderStore from './modules/lender'
import questionnaireStore from './modules/questionnaire'
import * as feathers from './modules/feathers'

Vue.use(Vuex)

const state = {
  scrolled: false,

  providerDescriptions: null,
}

const mutations = {
  SET_SCROLLED: (state, { scrolled }) => {
    state.scrolled = scrolled || false
  },

  SET_PROVIDER_DESCRIPTIONS: (state, descriptions) => {
    state.providerDescriptions = descriptions
  },
}

const actions = {
  async retrieveProviderDescriptions (context, force = false) {
    if (!force && context.state.providerDescriptions) return
    const metaService = context.getters['feathers/apiMeta']

    try {
      const data = await metaService.get('providerDescriptions')
      context.commit('SET_PROVIDER_DESCRIPTIONS', data.value)
    } catch (error) {}
  },
}
const getters = {}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    alertStore,
    authStore,
    lenderStore,
    questionnaireStore,
    feathers,
  },
  plugins: [createPersistedState({
    paths: ['authStore'],
  })],
})
